<template>
<content-form-register class="content-form-register mt-1">
    <LoadingApp
        :isLoading.sync="isLoading"
        :is_full_page="false"
    />
    <form-registration>
        <div v-if="!accept_only_pj_customers" class="col-12">
            <div class="d-flex align-items-center">
                <c-form-group class="form-group d-flex align-items-center" style="margin-right: 1.5rem;">
                    <input
                        type="radio"
                        value="F"
                        v-model="user_type"
                        id="pf"
                        class="tipo_pessoa"
                        name="user_type"
                        @change="typePerson(user_type)"
                    />
                    <label style="margin: 0 0 0 5px;" for="pf">Pessoa Física</label>
                </c-form-group>
                <c-form-group class="form-group d-flex align-items-center">
                    <input
                        type="radio"
                        value="J"
                        v-model="user_type"
                        id="pj"
                        class="tipo_pessoa"
                        name="user_type"
                        @change="typePerson(user_type)"
                    />
                    <label style="margin: 0 0 0 5px;" for="pj">Pessoa Jurídica</label>
                </c-form-group>
            </div>
            <div v-if="$v.user_type.$error && !$v.user_type.required" class="required">* Selecione o tipo de conta</div>
        </div>
        <div class="col-12">
            <h2 v-if="user_type === 'J'">Dados da empresa</h2>
            <h2 v-else>Dados pessoais</h2>
        </div>
        <div class="col-12">
            <div class="row">
                <div class="col-lg-6 mb-2">
                    <c-form-group class="form-group required-field ">
                        <label for="email">Email</label>
                        <input
                            type="email"
                            class="form-control disabled"
                            id="email"
                            v-model="email"
                            name="email"
                        />
                        <div v-if="$v.email.$error && !$v.email.required" class="required">* Email obrigatório</div>
                        <div v-else-if="$v.email.$error && !$v.email.email" class="required">* Email inválido</div>
                    </c-form-group>
                </div>
                <div class="col-lg-6 mb-2">
                    <c-form-group class="form-group required-field">
                        <label for="cpfcnpj" id="type_person">{{ setTypeRegister(user_type) }}</label>
                        <input
                            type="text"
                            class="form-input form-wide"
                            id="cpfcnpj"
                            name="user_cpfcnpj"
                            v-mask="maskRegister"
                            v-model="user_cpfcnpj"
                            @keypress.enter.prevent
                            @change="getCnpj"
                        />
                        <span v-if="$v.user_cpfcnpj.$error && !$v.user_cpfcnpj.required" class="required">* {{ setTypeRegister(user_type) }} obrigatório</span>
                        <span v-else-if="$v.user_cpfcnpj.$error && !$v.user_cpfcnpj.minLength" class="required">* {{ setTypeRegister(user_type) }} inválido</span>
                    </c-form-group>
                </div>

                <template v-if="user_type === 'J'">
                    <div class="col-lg-6 mb-2">
                        <c-form-group class="form-group required-field">
                            <label for="fantasy_name">Nome fantasia</label>
                            <input
                                type="text"
                                class="form-input form-wide "
                                id="fantasy_name"
                                name="user_fantasy_name"
                                v-model="user_fantasy_name"
                            />
                            <div v-if="$v.user_fantasy_name.$error && !$v.user_fantasy_name.required" class="required">* Nome fantasia obrigatório</div>
                        </c-form-group>
                    </div>
                    <div class="col-lg-6 mb-2">
                        <c-form-group class="form-group required-field">
                            <label for="user_company_name">Razão social</label>
                            <input
                                type="text"
                                class="form-input form-wide "
                                id="user_company_name"
                                v-model="user_company_name"
                                name="user_company_name"
                            />
                            <div v-if="$v.user_company_name.$error && !$v.user_company_name.required && user_type === 'J'"  class="required">* Razão social obrigatório</div>
                        </c-form-group>
                    </div>
                    <div class="col-lg-6 mb-2">
                        <div class="d-flex">
                            <c-form-group class="form-group">
                                <label for="user_ie">Inscrição estadual</label>
                                <input
                                
                                    type="text"
                                    class="form-input form-wide "
                                    id="user_ie"
                                    name="user_ie"
                                    v-model="user_ie"
                                    :readonly="IE_mandatory ? IE_mandatory : user_isento"
                                    :disabled="IE_mandatory ? IE_mandatory : user_isento"
                                    @input="handleInputIsento"
                                />
                                <div v-if="$v.user_ie.$error && !$v.user_ie.required" class="required">* Inscrição estadual obrigatório</div>
                            </c-form-group>
                            <c-form-group class="form-group ml-2">
                                <label class="text-center">Isento</label>
                                <input  type="checkbox" class="form-input form-wide " style="display:none;" id="user_isento" v-model="user_isento"  name="user_isento">
                                <ul class="config-swatch-list">
                                    <li @click="checkIsento(user_isento);" id="li_isento" :class="[user_isento ? 'inputIsentoChecked': '', 'active input_checkbox']" >
                                        <a></a>
                                    </li>
                                </ul>
                            </c-form-group>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="col-lg-6 mb-2">
                        <c-form-group class="form-group required-field">
                            <label for="name">Nome e sobrenome</label>
                            <input
                                type="text"
                                class="form-input form-wide "
                                id="name"
                                v-model="user_company_name"
                                name="name"
                                @blur="$v.user_company_name.$touch()"
                            />
                            <div v-if="$v.user_company_name.$error && !$v.user_company_name.required && user_type === 'F'" class="required">* Nome obrigatório</div>
                            <div v-if="!$v.user_company_name.twoStrings && $v.user_company_name.$error" class="required">* Por favor, insira nome e sobrenome</div>
                        </c-form-group>
                    </div>
                    <div class="col-lg-6 mb-2">
                        <c-form-group class="form-group required-field">
                            <label for="user_birthday">Data de nascimento</label>
                            <input
                                type="text"
                                class="form-input form-wide  data_nasc"
                                id="user_birthday"
                                v-model="user_birthday"
                                name="user_birthday"
                                v-mask="'##/##/####'"
                            />
                            <div v-if="$v.user_birthday.$error && !$v.user_birthday.required" class="required">* Data de nascimento obrigatório</div>
                        </c-form-group>
                    </div>
                </template>
            </div>
        </div>
        <template v-if="user_type === 'J'">
            <div class="col-12"><h2>DADOS DO RESPONSÁVEL</h2></div>
            <div class="col-12">
                <div class="row">
                    <div class="col-lg-6 mb-2">
                        <c-form-group class="form-group required-field">
                            <label for="register_responsible_name">Nome do responsável</label>
                            <input
                                type="text"
                                class="form-input form-wide "
                                id="register_responsible_name"
                                v-model="responsible_name"
                                name="responsible_name"
                            />
                            <div v-if="$v.responsible_name.$error && !$v.responsible_name.required" class="required">* Nome do responsável obrigatório</div>
                        </c-form-group>
                    </div>
                    <div class="col-lg-6 mb-2">
                        <c-form-group class="form-group ">
                            <label for="register_responsible_cpf">CPF do responsávels </label>
                            <input
                                type="text"
                                class="form-input form-wide "
                                id="register_responsible_cpf"
                                v-mask="masRegisterContact"
                                v-model="responsible_cpf"
                                name="responsible_cpf"
                            />
                            <!-- <div v-if="$v.responsible_cpf.$error && !$v.responsible_cpf.required" >* CPF do responsável obrigatório</div> -->
                        </c-form-group>
                    </div>
                </div>
            </div>
        </template>
        <div class="col-12">
            <div class="row">
                <div class="col-lg-6 mb-2">
                    <c-form-group class="form-group required-field">
                        <label for="phone">Telefone</label>
                        <input
                            type="text"
                            class="form-input form-wide "
                            id="phone"
                            v-model="phone"
                            v-mask="maskPhone(phone)"
                            name="phone"
                        />
                        <div v-if="$v.phone.$error && !$v.phone.required" class="required">* Telefone obrigatório</div>
                    </c-form-group>
                </div>
                <div class="col-lg-6 mb-2">
                    <c-form-group class="form-group required-field">
                        <div class="d-flex align-items-center">
                            <input
                                type="checkbox"
                                class="form-input form-wide"
                                id="use_with_whatsapp"
                                v-model="use_with_whatsapp"
                                name="use_with_whatsapp"
                                style="width:20px;margin-top: 3px;margin-right:5px"
                            />
                            <label for="use_with_whatsapp"><strong>Usar telefone como whatsapp</strong></label>
                        </div>
                    </c-form-group>
                </div>
                <div v-if="use_with_whatsapp == false" class="col-lg-6 mb-2">
                    <c-form-group :class="`form-group ${whatsapp_mandatory ? 'required-field' : ''}`">
                        <label for="phone_number">Whatsapp</label>
                        <input
                            type="text"
                            class="form-input form-wide "
                            id="phone_number"
                            v-model="phone_number"
                            v-mask="maskPhone(phone_number)"
                            name="phone_number"
                        />
                        <div v-if="$v.phone_number.$error && !$v.phone_number.required" class="required">* Whatsapp obrigatório</div>
                    </c-form-group>
                </div>
            </div>
        </div>
        <template v-if="active_form_of_service">
            <div class="col-12"><h2>Atendimento</h2></div>
            <div class="col-12">
                <div class="row">
                    <div class="col-lg-6 mb-2">
                        <c-form-group :class="`form-group ${active_form_of_service ? 'required-field' : ''}`">
                            <label for="form_of_customer_service">Quero ser atendido pelo</label><br>
                            <select
                                v-model="id_employee_type"
                                name="form_of_customer_service"
                                id="form_of_customer_service"
                                class="form-input form-wide "
                            >
                                <option v-for="item in list_employee_types" :key="item.id" :value="item.id">
                                    {{ item.name_type }}
                                </option>
                            </select>
                            <div v-if="$v.id_employee_type.$error && !$v.id_employee_type.required" class="required">* Atendimento obrigatório</div>
                        </c-form-group>
                    </div>
                </div>
            </div>
        </template>
        <div class="col-12">
            <div class="row">
                <div class="col-lg-6 mb-2">
                    <c-form-group class="form-group required-field">
                        <label for="password">Senha (mínimo 6 caracteres)</label>
                        <input
                            type="password"
                            class="form-input form-wide "
                            id="password"
                            minlength="6"
                            v-model="password"
                            name="password"
                        />
                        <div v-if="$v.password.$error && !$v.password.required" class="required">* Senha obrigatório</div>
                        <div v-else-if="$v.password.$error && !$v.password.minLength" class="required"> Minímo de caracteres 6 </div>
                    </c-form-group>
                </div>
                <div class="col-lg-6 mb-2">
                    <c-form-group class="form-group required-field">
                        <label for="password_c">Confirmar senha</label>
                        <input
                            type="password"
                            class="form-input form-wide "
                            id="password_c"
                            minlength="6"
                            v-model="password_confirmation"
                            name="password_confirmation"

                        />
                        <div v-if="$v.password_confirmation.$error && !$v.password_confirmation.required" class="required">* Senha obrigatório</div>
                        <div v-else-if="$v.password_confirmation.$error && !$v.password_confirmation.sameAsPassword" class="required">As senhas precisam ser idênticas</div>
                    </c-form-group>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row">
                <div class="col-lg-6 mb-2" v-for="(file, index) in customer_files" :key="index">
                    <c-form-group class="form-group">
                        <label>
                            {{file.document_name}}
                        </label>
                        <input
                            type="file"
                            @change="onFileChange(index, $event)"
                            class="form-input form-wide required"
                            :id="file.document_name"
                            :name="file.document_name"
                        />
                        <div v-if="$v.customer_files.$each[index].archive.$error" class="required">
                            Este arquivo é obrigatório.
                        </div>
                    </c-form-group>
                </div>
            </div>
        </div>

        <template v-if="active_options_to_know">
            <div class="col-12">
                <div class="row">
                    <div class="col-lg-6 mb-2">
                        <c-form-group class="form-group">
                            <label for="form_of_customer_service">Conte como nos conheceu</label><br>
                            <select
                                v-model="option_to_know"
                                name="form_of_customer_service"
                                id="form_of_customer_service"
                                class="form-input form-wide "
                            >
                                <option v-for="item in options_to_know" :key="item.name" :value="item.label">
                                    {{ item.label }}
                                </option>
                            </select>
                        </c-form-group>
                    </div>
                </div>
            </div>
        </template>
        <div class="col-12">
            <c-form-group class="form-group">
                <div class="d-flex align-items-center">
                    <input
                        type="checkbox"
                        class="form-input form-wide required"
                        id="user_newsletter"
                        v-model="user_newsletter"
                        name="user_newsletter"
                        style="width:20px;margin-top: 3px;margin-right:5px"
                    />
                    <label for="user_newsletter">
                        Quero receber ofertas e novidades por e-mail
                    </label>
                </div>
            </c-form-group>
        </div>
        <div class="col-12 mb-2">
            <c-form-group class="form-group required-field">
                <div class="d-flex align-items-center">
                    <label for="accepted_terms">Ao continuar você concorda com nossa <c-link style="font-weight: 600;" target="_blank" :href="$baseUrl+'page/politica-privacidade'">política de privacidade</c-link>.</label>
                </div>
            </c-form-group>
        </div>
        <div class="col-12">
            <div class="row">
                <div class="col-12">
                    <c-button
                        :backgroundColor="$root.$children[0].theme.products.button.background_color"
                        :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                        :color="$root.$children[0].theme.products.button.color"
                        :colorHover="$root.$children[0].theme.products.button.color_hover"
                        :borderColor="$root.$children[0].theme.products.button.border_color"
                        :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                        :borderRadius="$root.$children[0].theme.products.button.border_radius"
                        @click.prevent="submit"
                        margin="0 0 20px 0"
                        :textTransform="$root.$children[0].theme.products.button.text_transform"
                        height="unset"
                        minWidth="124px"
                        padding="1rem 2rem"
                        display="inline-block"
                        textAlign="center"
                        lineHeight="1.5"
                        letterSpacing=".1rem"
                        transition="all .3s"
                        class="float-right"
                    >
                        Finalizar
                    </c-button>
                </div>
            </div>
        </div>
    </form-registration>

    <!-- <form-wizard
        title=""
        subtitle=""
        @on-complete="submit"
        back-button-text="Voltar"
        next-button-text="Próximo"
        finish-button-text="Finalizar"
        :color="$root.$children[0].theme.primary_color"
    >
        <tab-content title="Dados pessoais" :before-change="()=>validateStep('DadosPessoais')">
            <DadosPessoais
                ref="DadosPessoais"
                @on-validate="mergePartialModels"
            />

        </tab-content>
        <tab-content title="Endereço" :before-change="()=>validateStep('Endereco')">
            <Endereco
                ref="Endereco"
                @on-validate="mergePartialModels"
            />
        </tab-content>
    </form-wizard> -->
</content-form-register>
</template>

<script>
import { required, minLength, requiredIf, sameAs, email } from 'vuelidate/lib/validators'
import { mapActions, mapState } from 'vuex'
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import DadosPessoais from './DadosPessoais'
import Endereco from './Endereco'
import LoadingApp from '../../LoadingApp'
import { CContentFormRegister, CRegistrationForm } from '../../Styles/Template/styled'
import { CFormGroup, CHeading3, CLink } from '../../Styles/Components/styled'
import ConsultaCep from '../../../api/consultaCep'
import { CButton } from '../../Styles/Button/styled'
import { swall } from '../../../services/sweetAlert'
import { ValidatorHelper } from '../../../helpers/ValidatorHelper'
import consultaCnpj from '../../../services/consultaCnpj'

export default {
    name: 'Register',
    props: {
        modal_name:{required:true, type:String},
        redirect:{default:false},
        url_previous:{default:null},
        host:{default:null},
        settings: { type: Array,
                    required: false,
                    default: Array}
    },
    components: {
        FormWizard,
        TabContent,
        DadosPessoais,
        Endereco,
        LoadingApp,
        'content-form-register': CContentFormRegister,
        'c-form-group': CFormGroup,
        'c-heading-3': CHeading3,
        'form-registration': CRegistrationForm,
        'c-link': CLink,
        'c-button': CButton
    },
    data() {
        return {
            form: {},
            isLoading: false,
            accept_only_pj_customers: this.$root.$children[0].$attrs.company?.settings?.accept_only_pj_customers ?? false,
            whatsapp_mandatory: this.$root.$children[0].$attrs.company?.settings?.whatsapp_mandatory ?? false,
            IE_mandatory:this.$root.$children[0].$attrs.company?.settings?.IE_mandatory ?? false,
            cnaes: this.$root.$children[0].$attrs.company?.cnaes || [],
            active_form_of_service: this.$root.$children[0].$attrs.company?.settings?.active_form_of_service ?? false,
            maskRegister: "###.###.###-##",
            masRegisterContact: "###.###.###-##",
            email: null,
            user_type: 'F',
            user_cpfcnpj: null,
            isCommerce: false,
            name: null,
            user_cnaes: [],
            user_birthday: null,
            user_fantasy_name: null,
            user_company_name: null,
            user_ie: null,
            user_isento: true,
            password: null,
            password_confirmation: null,
            name: null,
            lastname: null,
            phone_number: null,
            responsible_name: null,
            id_employee_type: null,
            user_newsletter: true,
            responsible_cpf: null,
            postal_code: null,
            address: null,
            city: null,
            uf: null,
            number: null,
            complement: null,
            district: null,
            phone: null,
            ibge: null,
            accepted_terms:true,
            use_with_whatsapp: false,
            customer_files: this.settings[0]?.settings ?? [],
            active_options_to_know: this.$root.$children[0].$attrs.company?.settings?.active_options_to_know ?? false,
            options_to_know: [
                { label: 'E-mail', value: 'e-mail' },
                { label: 'Facebook', value: 'facebook' },
                { label: 'Google/Busca Online', value: 'online-search' },
                { label: 'Instagram', value: 'instagram' },
                { label: 'Indicação', value: 'indication' },
                { label: 'Publicidade', value: 'advertising' },
            ],
            option_to_know: null,
            atividade_principal: [],
            atividades_secundarias: [],
        }
    },
    validations: {
        email: {required, email},
        user_type: {required},
        user_cpfcnpj:{
            required,
            minLength: minLength(14)
        },
        user_birthday:{required: requiredIf(function(val) {
            return this.user_type === 'F'
        })},
        user_fantasy_name: {required: requiredIf(function(val) {
            return this.user_type === 'J'
        })},
        user_company_name: {
            required,
            twoStrings(val) {
                if (!val) return true;
                const parts = val.trim().split(/\s+/);
                return parts.length >= 2;
            }
        },
        id_employee_type: {
            required: requiredIf(function(val) {
                return this.active_form_of_service == true
            })
        },
        user_ie: {
            required: requiredIf(function(val) {
                return this.user_type === 'J' && this.user_isento === false
            })
        },
        user_isento: {
            required: requiredIf(function(val) {
                return this.user_type === 'J' && val === true
            })
        },
        password: {
            required,
            minLength: minLength(6)
        },
        password_confirmation: {
            required,
            sameAsPassword: sameAs('password')
        },
        phone_number: {
            required: requiredIf(function() {
                return this.whatsapp_mandatory == true && this.use_with_whatsapp == false
            }),
        },
        phone: {required},
        accepted_terms:{required},
        responsible_name:{
            required: requiredIf(function(val) {
                return this.user_type === 'J'
            })
        },
        // responsible_cpf:{
        //     required: requiredIf(function(val) {
        //         return this.user_type === 'J'
        //     })
        // },
        customer_files: {
            $each: {
                archive: {
                    required: requiredIf(function (val) {
                        return val.document_required == true && (!val.archive || val.archive.length === 0);
                    }),
                },
            },
        }
    },
    mounted() {
        if(this.accept_only_pj_customers) {
            this.user_type = 'J'
            this.typePerson('J')
        }
        if(this.IE_mandatory){
            this.user_isento = false 
        }
        

    },
    methods: {
        ...mapActions("clients", [
            "ActionRegisterClient",
            "ActionGetClient",
            "ActionLogout"
        ]),
        maskPhone(phone) {
            if(phone?.length == 14) {
                return '(##) ####-####'
            } else {
                return '(##) #####-####'
            }
        },
        setTypeRegister(type) {
            if(type === 'F') {
                return 'CPF'
            }
            return 'CNPJ'
        },
        onFileChange(index, event) {
            const file = event.target.files[0];
                if (file) {
                    this.$set(this.customer_files, index, {
                        ...this.customer_files[index],
                        archive: file
                    });
                }
        },

        verificarCnae() {
            console.log(JSON.parse(this.cnaes))
            if(this.user_type == 'J'){
                const prefix =  this.atividade_principal[0].code.trim().substring(0,2)
                const JSONTranform = JSON.parse(this.cnaes)
                this.isCommerce =  JSONTranform.length > 0 ? JSONTranform.includes(prefix) : true
            }
        },

        async consultaCep(cep_consulta) {
            if(!cep_consulta) {
                return
            }
            try {
                let {
                    erro=null,
                    bairro=null,
                    cep=null,
                    complemento=null,
                    gia=null,
                    ibge=null,
                    localidade=null,
                    logradouro=null,
                    uf=null,
                    unidade=null

                } = await ConsultaCep.get(cep_consulta)
                if(erro) {
                    alert('CEP inválido!')
                    return
                }
                    this.city = localidade.toUpperCase()
                    this.uf = uf.toUpperCase()
                    this.district = bairro.toUpperCase()
                    this.address = logradouro.toUpperCase()
                    this.complement = complemento
                    this.ibge = ibge
            } catch(error) {
                alert(error)
            }
        },
        checkIsento(isento) {
            if(this.IE_mandatory){
                this.user_isento = false
                return
            }

            if(isento === false) {
                this.user_isento = true
                this.user_ie = null
                return
            }
            this.user_isento = false
            this.user_ie = null
        },
        handleInputIsento(){
            if(this.user_ie  && this.user_ie.trim() !== ''){
                this.user_isento = false                
            }
        },
        typePerson(type) {
            this.user_cpfcnpj = null
            if(type === 'F') {
                this.maskRegister = "###.###.###-##"
                return
            }
            this.user_birthday = null
            this.user_fantasy_name = null
            this.user_company_name = null
            this.maskRegister = "##.###.###/####-##"
        },
        setValidator(validator) {
            let errors = ''
            let msg = ''
            for (var [key, value] of Object.entries(validator)) {
                errors += value+'\n'
            }
            if(validator.file) {
                msg = errors + '\n' + 'Caso houver dúvidas entre em contato com nossa equipe'
            }
            else msg = errors + '\n' + 'Por favor entre em contato com nossa equipe ou clique em "Esqueceu sua senha?"'
            this.$swal({
                    title: `<p style="color: ${this.$root.$children[0].theme?.text_site_color ?? '#4a505e'}; display: inline-block; padding-bottom: 20px; padding: 8px; font-size: 1.6rem; font-weight: 500;">
                            ${msg}
                            </p>`,
                    icon: 'warning',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: `<span style="font-size: 1.6rem; font-weight: 500">OK</span>`,
                    background: this.$root.$children[0].theme?.background_color_site ?? '#fff',
                    width: '50em',
                })
        },
        async submit() {
            this.isLoading = true
            this.submitted = true
            if(this.user_type == 'J') {
                this.isLoading = false
                if (!ValidatorHelper.cnpj(this.user_cpfcnpj)) {
                    return swall('CNPJ inválido', true)
                }
            }else {
                this.isLoading = false
                if (!ValidatorHelper.cpf(this.user_cpfcnpj)) {
                    return swall('CPF inválido', true)
                }
            }

            if(this.IE_mandatory && this.user_type == 'J'){
                this.isLoading = false
               
                console.log(this.isCommerce)
                if(this.user_ie === null){
                    
                    return swall('Inscrição estadual Invalida, verifique seu cadastro.', true)
                }

                if(this.isCommerce === false){
                    return swall('CNAE inválidos, não condizem com as policas prevista no site', true)
                }

            }

            if (this.$v.$invalid) {
                this.isLoading = false
                this.$swal({
                    title: `<span style="color: ${this.$root.$children[0].theme?.text_site_color ?? '#4a505e'}; display: inline-block; padding-bottom: 20px; padding: 8px; font-size: 2rem; font-weight: 600;">
                            Preencha os campos obrigatórios!
                        </span>`,
                    icon: 'warning',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: `<span style="font-size: 1.6rem; font-weight: 500">OK</span>`,
                    background: this.$root.$children[0].theme?.background_color_site ?? '#fff',
                })
                this.$v.$touch()
                return
            }
            await this.send()
        },
        async send() {
            const formData = new FormData();
                formData.append("email", this.email),
                formData.append("user_type", this.user_type),
                formData.append("user_cpfcnpj", this.user_cpfcnpj),
                formData.append("name", this.name),
                formData.append("user_birthday", this.user_birthday),
                formData.append("user_fantasy_name", this.user_fantasy_name ?? ''),
                formData.append("user_company_name", this.user_company_name),
                formData.append("user_ie", this.user_ie ? this.user_ie : ''),
                formData.append("user_isento", this.user_isento),
                formData.append("password", this.password),
                formData.append("password_confirmation", this.password_confirmation),
                formData.append("lastname", this.lastname),
                formData.append("postal_code", this.postal_code ?? ''),
                formData.append("address", this.address ?? ''),
                formData.append("city", this.city ?? ''),
                formData.append("uf", this.uf ?? ''),
                formData.append("number", this.number ?? ''),
                formData.append("complement", this.complement ?? ''),
                formData.append("district", this.district ?? ''),
                formData.append("phone", this.phone ?? ''),
                formData.append("ibge", this.ibge ?? ''),
                formData.append("accepted_terms", this.accepted_terms),
                formData.append("phone_number", this.use_with_whatsapp ? this.phone : this.phone_number),
                formData.append("responsible_name", this.responsible_name),
                formData.append("responsible_cpf", this.responsible_cpf),
                formData.append("id_employee_type", this.id_employee_type ? this.id_employee_type : ''),
                formData.append("user_newsletter", this.user_newsletter),
                this.customer_files.forEach((fileItem) => {
                    if (fileItem.archive) {
                    formData.append(fileItem.document_name, fileItem.archive);
                    }
                })
                formData.append("option_to_know", this.option_to_know ?? ''),

            await this.ActionRegisterClient(formData)
            .then(async (response) => {
                let { error, msg, validator=null } = await response
                if(error) {
                    if(validator) {
                         this.setValidator(validator)
                        return
                    }
                    alert(msg)
                    return
                }
                if(this.facebookPixel?.settings?.CompleteRegistration == true) {
                    fbq('track', 'CompleteRegistration');
                }
                await this.ActionGetClient()
                this.$root.closeModalApp(this.modal_name)
                this.isLoading = false
                if(!this.clientLogged && this.company.settings.form_link) {
                    this.isLoading = false
                    this.$swal({
                        title: `<p style="color: ${this.$root.$children[0].theme?.text_site_color ?? '#4a505e'}; display: inline-block; padding-bottom: 20px; padding: 8px; font-size: 2rem; font-weight: 500;">
                            Para analisarmos seu cadastro, por gentileza preencha o formulário no link abaixo
                            </p>`,
                        icon: 'warning',
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: `<style> .button-form:hover { color: #fff;}</style><span style="font-size: 1.6rem; font-weight: 500;"><a class="button-form"href="${this.company.settings.form_link}" style="color: #fff; text-decoration:none" target="_blank">Acessar</a></span>`,
                        background: this.$root.$children[0].theme?.background_color_site ?? '#fff',
                        width: '50em',
                        allowEscapeKey: false,
                        allowOutsideClick: false
                    })
                    this.$v.$touch()
                    return
                }
                else if(!this.clientLogged) {
                    alert('Seu cadastro está sendo analisado. Em breve entraremos em contato!')
                } else {
                    alert('Sua conta foi criada com sucesso!')
                }

                if(this.redirect) {
                    if(!this.url_previous) {
                        window.location.href = this.$baseUrl
                        return
                    }
                    if(this.url_previous == this.host+this.$baseUrl+'cart') {
                        window.location.href = this.$baseUrl+'checkout'
                        return
                    }
                    if(this.url_previous) {
                        window.location.href = this.url_previous
                        return
                    }
                }
            })
            .catch((error) => {
                console.log(error)
                this.isLoading = false
                if(error.validator) {
                    this.setValidator(error.validator)
                    return
                }
                if(error.msg) {
                    alert(error.msg)
                    return
                }
                alert(error)

            })
        },
        validateStep(name) {
            var refToValidate = this.$refs[name];
            return refToValidate.validate();
        },
        mergePartialModels(model, isValid){
            if(isValid){
                // merging each step model into the final model
                this.form = Object.assign({},this.form, model)
            }
        },
        getCnpj() {
            if(this.user_type == 'F') {
                return;
            }
            if (!ValidatorHelper.cnpj(this.user_cpfcnpj)) {
                return swall('CNPJ inválido', true)
            }
            const cnpj = this.user_cpfcnpj;
            
            consultaCnpj.get(cnpj)
            .then((r) => {
                const data = r.data;
                this.user_company_name = data.nome
                this.user_fantasy_name = data.fantasia
                this.address = data.logradouro
                this.postal_code = data.cep.replace('.', '');
                this.phone = data.telefone
                this.city = data.municipio
                this.uf = data.uf
                this.number = data.numero
                this.complement = data.complemento
                this.district = data.bairro
                this.user_birthday = data.abertura
                this.user_ie = data.inscricao_estadual
                this.atividade_principal = data.atividade_principal || []
                this.atividades_secundarias = data.atividades_secundarias || []
                this.verificarCnae()
            })
        
            .catch(console.log)
        },
        containsExactlyTwoStrings(target) {
            const parts = target.trim().split(/\s+/);
            return parts.length >= 2;
        }
    },
    watch: {
        email_register(email) {
            this.email = email
        },
        use_with_whatsapp(val) {
            if(!val) {
                this.phone_number = null
            }
        },
        user_ie(newVal) {
            if (newVal && newVal.trim() !== '') {
                this.user_isento = false
            }
  }
    },
    computed: {
        ...mapState('company',[
            'facebookPixel',
            'company'
        ]),
        ...mapState("clients", [
            "email_register",
            'clientLogged',
            "list_employee_types"
        ])
    }
}
</script>

<style scoped>
.content-form-register {
    display:flex;
    justify-content:center;
    margin-top:30px;
}
.inputIsentoChecked {
    background-color: green;
}
@media (max-width:990px) {
    .content-form-login {
        display:unset;
    }
}
</style>
